<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="pre_registros"
      class="elevation-1"
      :loading="is_loading"
      :search="search"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.created_at }}</td>
          <td class="text-xs-left">{{ props.item.desarrollo }}</td>
          <td class="text-xs-left">{{ props.item.subcondominio }}</td>
          <td class="text-xs-left">{{ props.item.n_vivienda }}</td>
          <td class="text-xs-left">{{ props.item.fullname_contacto }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">
            <v-tooltip bottom v-if = "props.item.status !== 'PENDIENTE'">
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="show_preregistro(props.item.walkin_id)"
                        v-on="on" class="mr-2" small>
                  visibility
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="show_preregistro(props.item.walkin_id)"
                        v-on="on" class="mr-2" small>
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-container grid-list-md>
      <v-dialog v-model="infodialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_info_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ form_title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items v-show="this.editing === true">
              <v-btn dark flat @click.prevent="send_form">Guardar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container grid-list-md fluid>
            <v-alert
              :value="alertDialog"
              :type="alertDialogType"
              outline
            >
              {{ alertDialogMessage }}
            </v-alert>
            <v-form
              ref="form"
              id="preregistro_form"
              v-model="valid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12 sm4 md4>
                  <v-select
                    v-model="status"
                    label="Estatus"
                    :items="tipo_status"
                    :readonly="!this.editing"
                    :rules="text_required_rules"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm4 md4>
                  <v-textarea
                    v-model="observaciones"
                    label="Observaciones"
                    no-resize
                    rows="1"
                    :value="observaciones"
                    :readonly="!this.editing"
                    :rules="text_required_rules"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6 sm4 md4>
                  <v-textarea
                    v-model="notas"
                    label="Notas"
                    no-resize
                    rows="1"
                    :value="observaciones"
                    :readonly="true"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="preregistro_info.created_at"
                    label="Fecha"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="desarrollo"
                    label="Condominio"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Sub-Condominio"
                    readonly
                    v-model="subcondominio"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="n_vivienda"
                    label="Vivienda"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  Datos Personales del Contacto
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="nombre_contacto"
                    label="Nombre(s)"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="apellido_paterno_contacto"
                    label="Apellido Paterno"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="apellido_materno_contacto"
                    label="Apellido Materno"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <template v-for="(visitante, index) in visitantes">
                    <v-layout row wrap v-bind:key="visitante.person_id">
                      <v-flex xs12 sm12 md12 class="text-md-left">
                        Datos Personales del Visitante No. {{ index + 1 }}
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          v-model="visitante.tipo"
                          label="Tipo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          v-model="visitante.empresa"
                          label="Empresa"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.motivo"
                          label="Motivo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.nombres"
                          label="Nombre(s)"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          v-model="visitante.apellidos"
                          label="Apellidos"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_rostro!==null"
                             :src="src_image(visitante.foto_rostro)"
                             style="width: 95%"
                             alt="foto_rostro"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_credencial_frente!==null"
                             :src="src_image(visitante.foto_credencial_frente)"
                             style="width: 95%"
                             alt="foto_credencial_frente"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="visitante.foto_credencial_trasera!==null"
                             :src="src_image(visitante.foto_credencial_trasera)"
                             style="width: 95%"
                             alt="foto_credencial_trasera"/>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <template v-for="(vehiculo, index) in vehiculos">
                    <v-layout row wrap v-bind:key="vehiculo.vehicle_id">
                      <v-flex xs12 sm12 md12 class="text-md-left">
                        Datos del Vehículo No. {{ index + 1 }}
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.placas"
                          label="Placas"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.color"
                          label="Color"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.marca"
                          label="Marca"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="vehiculo.modelo"
                          label="Modelo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_frontal!==null"
                             :src="src_image(vehiculo.foto_frontal)"
                             style="width: 95%"
                             alt="foto_frontal"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_lateral!==null"
                             :src="src_image(vehiculo.foto_lateral)"
                             style="width: 95%"
                             alt="foto_lateral"/>
                      </v-flex>
                      <v-flex xs12 sm4 md4>
                        <img v-show="vehiculo.foto_trasera!==null"
                             :src="src_image(vehiculo.foto_trasera)"
                             style="width: 95%"
                             alt="foto_trasera"/>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    headers: [
      { text: 'Fecha', value: 'created_at', sortable: true },
      { text: 'Condominio', value: 'desarrollo', sortable: true },
      { text: 'Sub-Condominio', value: 'subcondominio', sortable: true },
      { text: 'Vivienda', value: 'n_vivienda', sortable: true },
      { text: 'Nombre Contacto', value: 'fullname_contacto', sortable: true },
      { text: 'Estado', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    tipo_status: [
      { text: 'RECHAZADO', value: 'RECHAZADO' },
      { text: 'ACEPTADO', value: 'ACEPTADO' },
    ],
    status: { text: 'RECHAZADO', value: 'RECHAZADO' },
    desarrollo: '',
    subcondominio: '',
    n_vivienda: '',
    created_at: '',
    fullname_contacto: '',
    observaciones: '',
    notas: '',
    nombre_contacto: '',
    apellido_paterno_contacto: '',
    apellido_materno_contacto: '',
    visitantes: [],
    vehiculos: [],
    infodialog: false,
    editing: false,
    valid: true,
  }),
  computed: {
    pre_registros() {
      return this.$store.getters['preRegistro/preregistro_list'];
    },
    preregistro_info() {
      return this.$store.getters['preRegistro/preregistro_info'];
    },
    preregistro_submited() {
      return this.$store.getters['preRegistro/preregistro_submited'];
    },
    preregistro_processing() {
      return this.$store.getters['preRegistro/preregistro_processing'];
    },
    is_loading() {
      return this.$store.getters['preRegistro/is_loading'];
    },
    form_title() {
      return this.editing === false ? 'Detalles del Pre-Registro' : 'Editar Pre-Registro';
    },
    alertType() {
      return this.$store.getters['preRegistro/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['preRegistro/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['preRegistro/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['preRegistro/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['preRegistro/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['preRegistro/alertDialog'];
    },
  },
  watch: {
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    preregistro_info(val) {
      if (val.status !== 'PENDIENTE') {
        this.editing = false;
      } else {
        this.editing = true;
      }
      if (typeof val.walkin_id !== 'undefined') {
        this.init_edit_data(val);
      }
    },
    preregistro_submited(val) {
      if (val) {
        this.$refs.form.reset();
        this.close_info_dialog();
      }
    },
    preregistro_processing(val) {
      this.processing = val;
    },
  },
  methods: {
    src_image(image) {
      const base = 'data:image/jpeg;base64, ';
      if (typeof image !== 'undefined') {
        return base.concat(image);
      }
      return null;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelAutoUpdate() { clearInterval(this.timer); },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    init_edit_data(data) {
      this.status = data.status;
      this.observaciones = data.observaciones;
      this.notas = data.notas;
      this.created_at = data.created_at;
      this.desarrollo = data.desarrollo;
      this.subcondominio = data.subcondominio;
      this.n_vivienda = data.n_vivienda;
      this.nombre_contacto = data.nombre_contacto;
      this.apellido_paterno_contacto = data.apellido_paterno_contacto;
      this.apellido_materno_contacto = data.apellido_materno_contacto;
      this.visitantes = [...data.persons];
      this.vehiculos = [...data.vehicles];
    },
    show_preregistro(id) {
      this.$store.dispatch('preRegistro/fetchPreregistroInfo', id);
      this.infodialog = true;
    },
    fetch_preregistro_list() {
      if (!this.$store.getters['preRegistro/is_loading']) {
        this.$store.dispatch('preRegistro/clearPreregistrosAction');
        this.$store.dispatch('preRegistro/fetchPreregistros');
      }
    },
    close_info_dialog() {
      this.infodialog = false;
      this.editing = false;
      this.status = '';
      this.observaciones = '';
      this.created_at = '';
      this.desarrollo = '';
      this.subcondominio = '';
      this.n_vivienda = '';
      this.notas = '';
      this.nombre_contacto = '';
      this.apellido_paterno_contacto = '';
      this.apellido_materno_contacto = '';
      this.visitantes = [];
      this.vehiculos = [];
      this.$store.commit('preRegistro/clearPreregistroInfo');
      this.$store.commit('preRegistro/clearAlertDialog');
      this.$store.commit('preRegistro/resetPreregistroProcessing');
    },
    clear_null(value) {
      if (value === null || typeof value === 'undefined') {
        return '';
      }
      return value;
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('preRegistro/startedPreregistroProcessing');
        const formdata = {
          status: this.clear_null(this.status),
          observation: this.clear_null(this.observaciones),
          walkin_id: this.preregistro_info.walkin_id,
        };
        this.$store.dispatch('preRegistro/sendPreregistro', formdata);
        this.$store.commit('preRegistro/resetPreregistroSubmit');
      }
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
    this.cancelSearchTimer();
  },
  created() {
    if (!(this.$store.getters['preRegistro/preregistro_list'].length > 0)) {
      this.fetch_preregistro_list();
    } else {
      this.$store.commit('preRegistro/fetchedPreregistros');
    }
    this.timer = setInterval(this.fetch_preregistro_list, 60000);
  },
};
</script>
